import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["^width", "^height"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'PencilIcon',
  props: {
  size: {
    type: Number,
    default: 20,
  },
  color: {
    type: String,
    default: 'white',
  }
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "^width": __props.size,
    "^height": __props.size,
    viewBox: "0 0 512 512"
  }, [
    _createElementVNode("path", {
      fill: __props.color,
      d: "M432 0c44.182 0 80 35.817 80 80 0 18.010-5.955 34.629-16 48l-32 32-112-112 32-32c13.371-10.045 29.989-16 48-16zM32 368l-32 144 144-32 296-296-112-112-296 296zM357.789 181.789l-224 224-27.578-27.578 224-224 27.578 27.578z"
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})